$(document).ready(function(){
    $(".owl-movies").owlCarousel({
        center: true,
        items: 1,
        loop: true,
        autoplay:true,
        autoplayTimeout:6000,
        autoplayHoverPause:true,
        nav: true,
        navText: ['<i class="fa-thin fa-3x fa-angle-left" aria-hidden="true"></i>','<i class="fa-thin fa-3x fa-angle-right" aria-hidden="true"></i>']
    });
});

/*
 * Masonry Movie
 */
// var $gridMovie = $('.gridMovie').isotope({
//     itemSelector: '.gridMovie-item',
//     percentPosition: true,
//     masonry: {
//         // use outer width of grid-sizer for columnWidth
//         // columnWidth: '.grid-sizer'
//     }
// });
// // layout Isotope after each image loads
// $gridMovie.imagesLoaded().progress( function() {
//     $gridMovie.isotope('layout');
// });